import WebSocketService, { SocketEvents } from './WebsocketService';

export default WebSocketService;
export { SocketEvents };
